module.exports = __webpack_public_path__ + "img/sell-out.786433f1.png";